import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class BeneficiariesError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('BeneficiariesError', ...args);
    }
}
export default BeneficiariesError;
